import React, {useEffect, useState} from 'react';

import { ReactComponent as PFC } from "../customIcons/PFC.svg";
import {useDarkMode} from "../contexts/darkModeContext";
import {
    NoSymbolIcon, PercentBadgeIcon, UserGroupIcon,
} from "@heroicons/react/24/outline";
import {Button} from "@headlessui/react";
import {collection, getDocs} from "firebase/firestore";
import {db} from "../firebase/firebase";
import {useAuth} from "../contexts/authContext";
import {formatUnixTimestampToReadableString, getYearString} from "./GLOBAL/GlobalFunctions";
import Loading from "./Widgets/Loading";
import CSRStatusCard from "./CSRStatusCard";

const CSRStatus = () => {

    const { darkMode } = useDarkMode();
    
    const [CSRs, setCSRs] = useState([]);
    
    useEffect(() => {
        const fetchCSR = async () => {
            const usersCollection = collection(db, 'Users');
            const userSnapshot = await getDocs(usersCollection);
            const filteredUserList = userSnapshot.docs
                .map(doc => ({
                    id: doc.id,
                    name: `${doc.data().fname} ${doc.data().lname}`,
                    accountLevel: doc.data().accountLevel,
                    email: doc.data().email,
                    phone: doc.data().phone,
                    created: doc.data().created,
                    reps: doc.data().reps,
                    lastSeen: doc.data().lastSeen,
                }))
                .filter(user => ['CSR', 'A'].includes(user.accountLevel)); // ✅ updated
    
            setCSRs(filteredUserList);
        };
        
        fetchCSR();
    }, []);
    
    
    
    
    
    const [secondaryNavigation, setSecondaryNavigation] = useState([
      // { name: 'Dashboard', href: '#', current: false },
      // { name: 'Archived Status', href: 'A', current: false },
      { name: 'Current Status', href: 'C', current: true },
    ]);
    
    
    const [collapse] = useState(false);
    
    
    return (
        <div className={`${darkMode ? 'text-white' : 'text-black'} flex h-[calc(100dvh-3.5rem)] w-full transition-all duration-500 ease-in-out`}>
            
            {/*Redesign*/}
            <div className={`animate-fadeIn z-20 ${darkMode ? 'bg-darkMainColor text-white' : 'bg-white text-black'} w-full`}>
                
                
                
                <main>
                    
                    {/*Header*/}
                    <header>
                        {/* Secondary navigation */}
                        <nav className={`flex items-center justify-between overflow-x-auto border-b ${darkMode ? 'border-neutral-700' : 'border-gray-300'} py-2`}>
                            <div
                                role="list"
                                className="flex w-fit flex-none gap-x-6 px-4 text-sm/6 font-semibold text-gray-400 sm:px-6 lg:px-8"
                            >
                                {secondaryNavigation.map((item) => (
                                    <div
                                      key={item.name}
                                      onClick={() => {
                                        // setStatus(item.href);
                                        setSecondaryNavigation((nav) =>
                                          nav.map((navItem) => ({
                                            ...navItem,
                                            current: navItem.href === item.href,
                                          }))
                                        );
                                      }}
                                      className="cursor-pointer"
                                    >
                                      <div className={item.current ? 'text-green-600' : ''}>
                                        {item.name}
                                      </div>
                                    </div>
                                  ))}
                            </div>
                            
                            
                            

                            
                            {/*<Button*/}
                            {/*    onClick={toggleCollapse}*/}
                            {/*    className={`mx-4`}*/}
                            {/*>*/}
                            {/*    <ChevronDownIcon className={`${collapse ? 'rotate-180' : ''} transition-all duration-1000 size-6 text-green-600`}/>*/}
                            {/*</Button>*/}
                            
                        </nav>
                        
                        {/* Heading */}
                        <div className={`${collapse ? 'hidden' : ''} flex flex-col items-start justify-between gap-x-8 ${darkMode ? ' bg-gray-700/10' : 'bg-neutral-300/50'} px-4 py-2 sm:flex-row sm:items-center sm:px-6 lg:px-8`}>
                            <div>
                                <div className="flex items-center gap-x-3">
                                    <div className={`flex-none rounded-full bg-green-600/25 text-green-600 p-1`}>
                                        <div className="size-2 rounded-full bg-current"/>
                                    </div>
                                    <h1 className="flex gap-x-3 text-base/7">
                                        <span className="font-semibold">CSR Status</span>
                                        <span className="font-semibold text-gray-500">{formatUnixTimestampToReadableString(Date.now())}</span>
                                        <span className="text-gray-600">/</span>
                                        <span className="font-semibold">{CSRs.length} CSR Reps</span>
                                    </h1>
                                </div>
                                <p className="mt-2 text-xs/6 text-gray-500">This is the status of each of the CSR reps in the office. Along with the reps they are currently servicing</p>
                            </div>
                            
                        </div>
                        
                    </header>
                    
                    {/* Status Map */}
                    <div className="">
                        
                        
                        {/*Orders MAP*/}
                        <div className={`overflow-y-auto grid grid-cols-1 divide-x-2 h-[calc(100dvh-10.6rem)] border-b border-t scrollbar-hide ${darkMode ? 'text-white bg-darkMainColor border-neutral-700 divide-neutral-700' : 'text-black bg-white'} rounded-b-lg scrollbar-hide`}>
                            
                            {/*CSR*/}
                            <div className={`col-span-1 px-3 h-[calc(100dvh-11rem)] overflow-y-auto scrollbar-hide`}>
                                
                                <div className={`w-full`}>
                                    
                                    {CSRs.length === 0 ? (
                                        <div className="w-full h-full flex justify-center items-center">
                                            <div className={`flex items-center border-2 border-dashed ${darkMode ? "text-white border-borderColor" : "text-black bg-neutral-50"} w-fit px-24 py-6 h-fit mr-auto ml-auto justify-center rounded-lg hover:scale-105`}>
                                                <div className="text-center flex items-center flex-col">
                                                    <UserGroupIcon className={`size-12 stroke-1 text-white`}/>
                                                    <h3 className="mt-2 text-sm font-semibold">No CSR Reps</h3>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <div className={`grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 gap-3 py-3 auto-rows-auto`}>
                                                {CSRs.map((CSR, index) => (
                                                    <CSRStatusCard
                                                        key={index}
                                                        CSR={CSR}
                                                    />
                                                ))}
                                            
                                            </div>
                                        </>
                                    )}
                                
                                </div>
                                
                            </div>
                            
                           
                        </div>
                    
                    
                    </div>
                
                </main>
            
            </div>
        
        
        </div>
    )
};


export default CSRStatus;
